import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { groupBy } from 'lodash';
import classNames from 'classnames';
import useScreen from 'hooks/useScreen';
import Placeholder from 'components/consumer/Placeholder';
import PDPActiveFabric from 'components/consumer/PDP/PDPActiveFabric';
import PDPDecideLaterPromo from 'components/consumer/PDP/PDPDecideLaterPromo';
import PDPUpholsterySortBy from 'components/consumer/PDP/PDPUpholsterySortBy';
import MaterialThumbnailGroup from 'components/consumer/MaterialThumbnailGroup';
import PDPUpholsteryFilters from 'components/consumer/PDP/PDPUpholsteryFilters';
import PDPFabricDetailSidebar from 'components/consumer/PDP/PDPFabricDetailSidebar';
import PDPFreeSwatchKitButton from 'components/consumer/PDP/PDPFreeSwatchKitButton';
import PDPOrderSwatchesSidebar from 'components/consumer/PDP/PDPOrderSwatchesSidebar';
import PDPUpholsteryColorFilters from 'components/consumer/PDP/PDPUpholsteryColorFilters';
import { PDP_CUSTOMIZE_TAB_ID, PDP_READYTOSHIP_TAB_ID, PDP_DECIDELATER_TAB_ID, FABRIC_PRODUCT_OPTION_ID, LEATHER_PRODUCT_OPTION_ID, GRADE_NUMERAL_BY_VALUE, PDP_NAMED_FILTERS, PANTONE_FABRIC_CONFIG } from 'commons/constants';
import { materialPropType, productFilterTypes } from 'types/PDPTypes';
import useFabricDetails from 'data-hooks/useFabricDetails';
import useIsTouchDevice from 'hooks/useIsTouchDevice';
import usePdpIsModularBYOProduct from 'components/consumer/PDP/state/context/usePdpIsModularBYOProduct';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import CtaButton from 'components/essentials/Cta/CtaButton';
import useProjectResetConfig from 'data-hooks/useProjectResetConfig';
import MaterialThumbnailGroupPlaceholder from 'components/consumer/MaterialThumbnailGroup/MaterialThumbnailGroupPlaceholder';
import FlyoutContainer from '../../FlyoutContainer';
import PDPSelectUpholsteryDecideLater from './PDPSelectUpholsteryDecideLater';
const {
  pantoneFabricSkus
} = PANTONE_FABRIC_CONFIG;
const tiers = {
  1: {
    title: 'Tier 1',
    desc: 'Readily available fabrics that bring an eye-catching look to your piece at a great value.'
  },
  2: {
    title: 'Tier 2',
    desc: 'Kick things up a notch with fabrics that show off more rich colors, textures, and durability.'
  },
  3: {
    title: 'Tier 3',
    desc: 'Got an active home? Check out these fabrics that showcase top notch performance finishes while still looking stylish.'
  },
  4: {
    title: 'Tier 4',
    desc: 'As luxe as it gets, this tier includes our branded performance fabrics and stain resistant finish fabrics, ready to take on all life throws its way in sophisticated style.'
  }
};
const NUMBER_OF_SWATCHES_PER_ROW_ON_DESKTOP = 9;
const MAX_SWATCHES_BEFORE_SHOW_ALL_BUTTON = 3 * NUMBER_OF_SWATCHES_PER_ROW_ON_DESKTOP;
const SORT_BY_OPTIONS = {
  POPULARITY: 'popularity',
  FAMILY: 'family',
  TIER: 'tier'
};
const moveMaterialToSecondPosition = (materials, materialSku) => {
  if (materials?.length && materialSku && materials[0]?.sku !== materialSku) {
    const filteredMaterials = materials.filter(({
      sku
    }) => sku !== materialSku);
    const material = materials.find(({
      sku
    }) => sku === materialSku);
    const [firstMaterial, ...restMaterials] = filteredMaterials;
    return [firstMaterial, material, ...restMaterials];
  }
  return materials;
};
const PDPSelectUpholsteryUI = t0 => {
  const $ = _c(151);
  const {
    activeColorFilters,
    activeNamedFilters,
    allMaterialsLength,
    clearAllFilters,
    disabledMaterialIds,
    fabricFavProps,
    filterCounts: t1,
    flashSaleOptionIds: t2,
    isClearanceFabricAvailable,
    isEditOrder: t3,
    isSelectedOptionsQuickship,
    loading,
    materials,
    mode: t4,
    onMoreMaterialsClick,
    onOptionValueHover,
    onOptionValueSelection,
    selectedMaterial,
    selectedOptionsStockQty,
    toggleColorFilter,
    toggleNamedFilter,
    upholsteryFilteredEvent,
    upholsteryOptionId,
    upholsteryOptionName,
    isLayoutRevamp: t5
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const filterCounts = t6;
  let t7;
  if ($[2] !== t2) {
    t7 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const flashSaleOptionIds = t7;
  const isEditOrder = t3 === undefined ? false : t3;
  const mode = t4 === undefined ? "pdp" : t4;
  const isLayoutRevamp = t5 === undefined ? false : t5;
  const {
    isDesktop,
    isMobile
  } = useScreen();
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const [selectedSortOption, setSelectedSortOption] = useState(SORT_BY_OPTIONS.POPULARITY);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const [isOrderSwatchesSidebarOpen, setIsOrderSwatchesSidebarOpen] = useState(false);
  const [galleryType, setGalleryType] = useState("");
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {};
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const [sortByFlyOutContent, setSortByFlyOutContent] = useState(t8);
  const [isSortByFlyOutVisible, setIsSortByFlyOutVisible] = useState(false);
  const {
    data: t9
  } = useFabricDetails(selectedMaterial?.materialId);
  const {
    selectedFabric
  } = t9;
  const isTouchDevice = useIsTouchDevice();
  const isPdpMode = mode === "pdp";
  const isLayoutRevampPdp = isLayoutRevamp && isPdpMode;
  const isLeather = upholsteryOptionId === LEATHER_PRODUCT_OPTION_ID;
  const tierOrGradeLabel = isLeather ? "Grade" : "Tier";
  let t10;
  if ($[5] !== materials || $[6] !== selectedSortOption) {
    t10 = selectedSortOption === SORT_BY_OPTIONS.FAMILY ? groupBy(materials, "groupName") : {};
    $[5] = materials;
    $[6] = selectedSortOption;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const materialsGroupedByFamily = t10;
  let t11;
  if ($[8] !== isLeather || $[9] !== materials || $[10] !== selectedSortOption) {
    t11 = selectedSortOption === SORT_BY_OPTIONS.TIER ? groupBy(materials, isLeather ? "grade" : SORT_BY_OPTIONS.TIER) : {};
    $[8] = isLeather;
    $[9] = materials;
    $[10] = selectedSortOption;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const materialsGroupedByTier = t11;
  const isQuickview = mode === "quickview";
  const quickviewNumberOfFabricsToShow = isMobile ? 5 : 8;
  const limitNumberShownForQuickview = isQuickview && allMaterialsLength > quickviewNumberOfFabricsToShow;
  const {
    data: projectResetConfig
  } = useProjectResetConfig();
  let t12;
  if ($[12] !== projectResetConfig) {
    t12 = projectResetConfig ?? {};
    $[12] = projectResetConfig;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const {
    isProjectResetEnabled,
    projectResetNewFabricSkus
  } = t12;
  let t13;
  bb0: {
    let t14;
    if ($[14] !== isProjectResetEnabled || $[15] !== isQuickview || $[16] !== materials || $[17] !== projectResetNewFabricSkus?.[0]) {
      t14 = isQuickview ? moveMaterialToSecondPosition(materials, isProjectResetEnabled ? projectResetNewFabricSkus?.[0] : pantoneFabricSkus?.[0]) : materials;
      $[14] = isProjectResetEnabled;
      $[15] = isQuickview;
      $[16] = materials;
      $[17] = projectResetNewFabricSkus?.[0];
      $[18] = t14;
    } else {
      t14 = $[18];
    }
    const materialsPantoneFabricAsSecond = t14;
    if (limitNumberShownForQuickview) {
      let t15;
      if ($[19] !== materialsPantoneFabricAsSecond || $[20] !== quickviewNumberOfFabricsToShow) {
        t15 = materialsPantoneFabricAsSecond.slice(0, quickviewNumberOfFabricsToShow);
        $[19] = materialsPantoneFabricAsSecond;
        $[20] = quickviewNumberOfFabricsToShow;
        $[21] = t15;
      } else {
        t15 = $[21];
      }
      t13 = t15;
      break bb0;
    }
    t13 = materialsPantoneFabricAsSecond;
  }
  const ungroupedMaterialsArray = t13;
  const moreMaterialsCount = limitNumberShownForQuickview ? allMaterialsLength - quickviewNumberOfFabricsToShow : undefined;
  const ungroupedMaterialsLength = ungroupedMaterialsArray?.length ?? 0;
  const [hasShowAllFabricsButtonBeenClicked, setHasShowAllFabricsButtonBeenClicked] = useState(false);
  const isAllFabricsShown = !activeNamedFilters.length;
  const showShowAllFabricsButton = isDesktop && isAllFabricsShown && !loading && !hasShowAllFabricsButtonBeenClicked && ungroupedMaterialsLength > MAX_SWATCHES_BEFORE_SHOW_ALL_BUTTON;
  let t14;
  if ($[22] !== showShowAllFabricsButton || $[23] !== ungroupedMaterialsArray) {
    t14 = showShowAllFabricsButton ? ungroupedMaterialsArray.slice(0, MAX_SWATCHES_BEFORE_SHOW_ALL_BUTTON) : ungroupedMaterialsArray;
    $[22] = showShowAllFabricsButton;
    $[23] = ungroupedMaterialsArray;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const ungroupedMaterialsToShow = t14;
  let t15;
  if ($[25] !== isTouchDevice) {
    t15 = upholsteryOptionNameVal => {
      const tapOrClick = isTouchDevice ? "tap" : "click";
      return upholsteryOptionNameVal === "Fabric" ? `Double-${tapOrClick} a fabric to add to your favorites` : upholsteryOptionNameVal === "Leather" ? `Double-${tapOrClick} a leather to add to your favorites` : "Double tap to favorite";
    };
    $[25] = isTouchDevice;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const getFabricFavInfoToShow = t15;
  const noActiveNamedFilters = !activeNamedFilters.length;
  const noActiveColorFilters = activeColorFilters.length === 0;
  const noActiveFilters = noActiveNamedFilters && noActiveColorFilters;
  const t16 = !noActiveFilters;
  let t17;
  if ($[27] !== noActiveFilters || $[28] !== t16) {
    t17 = classNames("text-xs font-bold p-[5px] underline", {
      "text-gray-light4 pointer-events-none": noActiveFilters,
      "text-red hover:text-red-dark": t16
    });
    $[27] = noActiveFilters;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== clearAllFilters || $[31] !== noActiveFilters) {
    t18 = () => {
      if (!noActiveFilters) {
        clearAllFilters();
      }
    };
    $[30] = clearAllFilters;
    $[31] = noActiveFilters;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t17 || $[34] !== t18) {
    t19 = <button type="button" data-xc="PDPClearAllFiltersButton" className={t17} onClick={t18}>Clear All</button>;
    $[33] = t17;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  const clearAllFiltersButton = t19;
  let t20;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = (content, isVisible) => {
      setSortByFlyOutContent(content);
      setIsSortByFlyOutVisible(isVisible);
    };
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  const onToggleFlyOut = t20;
  let t21;
  if ($[37] !== isSortByFlyOutVisible || $[38] !== sortByFlyOutContent) {
    t21 = isSortByFlyOutVisible && <FlyoutContainer top={sortByFlyOutContent.top > 300 ? sortByFlyOutContent.top - 300 : sortByFlyOutContent.top} title={sortByFlyOutContent.title} content={sortByFlyOutContent.content} subTitle={sortByFlyOutContent.subTitle} imageUrl={sortByFlyOutContent.imageUrl} titleInfo={sortByFlyOutContent.titleInfo} titleExtra={sortByFlyOutContent.titleExtra} subSubTitle={sortByFlyOutContent.subSubTitle} onClose={() => setIsSortByFlyOutVisible(false)} isOpen={isSortByFlyOutVisible} />;
    $[37] = isSortByFlyOutVisible;
    $[38] = sortByFlyOutContent;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  const flyoutContainerContent = t21;
  let t22;
  if ($[40] !== disabledMaterialIds || $[41] !== fabricFavProps || $[42] !== flashSaleOptionIds || $[43] !== isEditOrder || $[44] !== materialsGroupedByFamily || $[45] !== onOptionValueHover || $[46] !== onOptionValueSelection || $[47] !== pdpIsModularBYOProduct || $[48] !== selectedMaterial || $[49] !== upholsteryOptionId) {
    t22 = Object.keys(materialsGroupedByFamily).sort().map(groupName => <div key={groupName} className="mb-8"><div className="text-sm font-bold text-gray">{groupName}</div><MaterialThumbnailGroup disabledMaterialIds={disabledMaterialIds} fabricFavProps={fabricFavProps} flashSaleOptionIds={flashSaleOptionIds} isEditOrder={isEditOrder} isModularBundleProduct={pdpIsModularBYOProduct} materials={materialsGroupedByFamily[groupName]} onClick={onOptionValueSelection} onHover={onOptionValueHover} onToggleFlyOut={onToggleFlyOut} optionId={upholsteryOptionId} selectedMaterial={selectedMaterial} /></div>);
    $[40] = disabledMaterialIds;
    $[41] = fabricFavProps;
    $[42] = flashSaleOptionIds;
    $[43] = isEditOrder;
    $[44] = materialsGroupedByFamily;
    $[45] = onOptionValueHover;
    $[46] = onOptionValueSelection;
    $[47] = pdpIsModularBYOProduct;
    $[48] = selectedMaterial;
    $[49] = upholsteryOptionId;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t22) {
    t23 = <div className="p-6 max-h-[472px] overflow-y-auto bg-gray-light9 border border-solid border-gray-light7">{t22}</div>;
    $[51] = t22;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  const sortByFamilyMaterialThumbnails = t23;
  const materialThumbnailVariant = mode === "quickview" ? "PDPSelectUpholsteryUI--quickview" : "PDPSelectUpholsteryUI";
  let t24;
  if ($[53] !== disabledMaterialIds || $[54] !== fabricFavProps || $[55] !== flashSaleOptionIds || $[56] !== isEditOrder || $[57] !== isLeather || $[58] !== materialThumbnailVariant || $[59] !== materialsGroupedByTier || $[60] !== mode || $[61] !== onOptionValueHover || $[62] !== onOptionValueSelection || $[63] !== pdpIsModularBYOProduct || $[64] !== selectedMaterial || $[65] !== tierOrGradeLabel || $[66] !== upholsteryOptionId) {
    t24 = Object.keys(materialsGroupedByTier).filter(_temp).sort(_temp2).map(tierId_0 => {
      const gradeNumeral = GRADE_NUMERAL_BY_VALUE[tierId_0] || String(tierId_0);
      const tierMeta = isLeather ? {
        title: `${tierOrGradeLabel} ${gradeNumeral}`,
        desc: ""
      } : tiers[tierId_0];
      return tierMeta ? <div key={tierId_0} className="mt-8"><div className="text-sm font-bold text-gray">{tierMeta.title}</div>{tierMeta.desc ? <div className="text-xs text-gray mb-[1.2rem]">{tierMeta.desc}</div> : <div className="mb-[1.2rem]" />}<div className={classNames("max-[1023px]:-ml-5 max-[1023px]:-mr-5 max-[1023px]:md:ml-[-3.333vw] max-[1023px]:md:mr-[-3.333vw]", {
          "max-[1023px]:md:!m-0": mode === "quickview"
        })}><MaterialThumbnailGroup disabledMaterialIds={disabledMaterialIds} fabricFavProps={fabricFavProps} flashSaleOptionIds={flashSaleOptionIds} isEditOrder={isEditOrder} isModularBundleProduct={pdpIsModularBYOProduct} materials={materialsGroupedByTier[tierId_0]} onClick={onOptionValueSelection} onHover={onOptionValueHover} optionId={upholsteryOptionId} selectedMaterial={selectedMaterial} variant={materialThumbnailVariant} /></div></div> : null;
    });
    $[53] = disabledMaterialIds;
    $[54] = fabricFavProps;
    $[55] = flashSaleOptionIds;
    $[56] = isEditOrder;
    $[57] = isLeather;
    $[58] = materialThumbnailVariant;
    $[59] = materialsGroupedByTier;
    $[60] = mode;
    $[61] = onOptionValueHover;
    $[62] = onOptionValueSelection;
    $[63] = pdpIsModularBYOProduct;
    $[64] = selectedMaterial;
    $[65] = tierOrGradeLabel;
    $[66] = upholsteryOptionId;
    $[67] = t24;
  } else {
    t24 = $[67];
  }
  let t25;
  if ($[68] !== t24) {
    t25 = <div>{t24}</div>;
    $[68] = t24;
    $[69] = t25;
  } else {
    t25 = $[69];
  }
  const sortByTierMaterialThumbnails = t25;
  let t26;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = () => {
      setGalleryType("");
      setSidebarOpen(false);
    };
    $[70] = t26;
  } else {
    t26 = $[70];
  }
  const onCloseCallback = t26;
  const showDesktopColorFilters = mode !== "quickview" && upholsteryOptionId === FABRIC_PRODUCT_OPTION_ID && !isMobile;
  let t27;
  if ($[71] !== activeColorFilters || $[72] !== activeNamedFilters || $[73] !== selectedSortOption || $[74] !== showDesktopColorFilters || $[75] !== toggleColorFilter || $[76] !== upholsteryFilteredEvent) {
    t27 = showDesktopColorFilters ? <div className="items-center flex justify-between w-full mb-4"><h4 className="text-base font-bold">Filter by color:</h4><PDPUpholsteryColorFilters activeColorFilters={activeColorFilters} toggleColorFilter={updatedColor => {
        toggleColorFilter(updatedColor);
        upholsteryFilteredEvent(activeNamedFilters, updatedColor, selectedSortOption);
      }} /></div> : <div />;
    $[71] = activeColorFilters;
    $[72] = activeNamedFilters;
    $[73] = selectedSortOption;
    $[74] = showDesktopColorFilters;
    $[75] = toggleColorFilter;
    $[76] = upholsteryFilteredEvent;
    $[77] = t27;
  } else {
    t27 = $[77];
  }
  const desktopColorFilterRow = t27;
  const showSortByRow = mode !== "quickview" && (upholsteryOptionId === FABRIC_PRODUCT_OPTION_ID || upholsteryOptionId === LEATHER_PRODUCT_OPTION_ID);
  let t28;
  if ($[78] !== activeColorFilters || $[79] !== activeNamedFilters || $[80] !== isLeather || $[81] !== selectedSortOption || $[82] !== showSortByRow || $[83] !== upholsteryFilteredEvent) {
    t28 = showSortByRow && <div className="hidden sm:block"><PDPUpholsterySortBy isLeather={isLeather} selectedOption={selectedSortOption} setSelectedOption={updatedSortOption => {
        setSelectedSortOption(updatedSortOption);
        upholsteryFilteredEvent(activeNamedFilters, activeColorFilters, updatedSortOption);
      }} /></div>;
    $[78] = activeColorFilters;
    $[79] = activeNamedFilters;
    $[80] = isLeather;
    $[81] = selectedSortOption;
    $[82] = showSortByRow;
    $[83] = upholsteryFilteredEvent;
    $[84] = t28;
  } else {
    t28 = $[84];
  }
  const sortByRow = t28;
  const showSwatchKitButton = !!isPdpMode && pdpSelectedCustomizerTab !== PDP_READYTOSHIP_TAB_ID && !isEditOrder;
  const showShowLessFabricsButton = isLayoutRevampPdp && isDesktop && isAllFabricsShown && !loading && hasShowAllFabricsButtonBeenClicked && ungroupedMaterialsLength > MAX_SWATCHES_BEFORE_SHOW_ALL_BUTTON;
  let t29;
  let t30;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = () => {
      setIsOrderSwatchesSidebarOpen(false);
    };
    t30 = () => {
      setIsOrderSwatchesSidebarOpen(false);
    };
    $[85] = t29;
    $[86] = t30;
  } else {
    t29 = $[85];
    t30 = $[86];
  }
  let t31;
  if ($[87] !== isOrderSwatchesSidebarOpen) {
    t31 = <PDPOrderSwatchesSidebar show={isOrderSwatchesSidebarOpen} onClose={t29} closeSlidePanel={t30} />;
    $[87] = isOrderSwatchesSidebarOpen;
    $[88] = t31;
  } else {
    t31 = $[88];
  }
  const orderSwatchesSidebar = t31;
  const t32 = mode !== "quickview";
  let t33;
  if ($[89] !== t32) {
    t33 = classNames("relative", {
      "[border-bottom:1px_solid_#e5e5e5] mb-2 pb-8": t32
    });
    $[89] = t32;
    $[90] = t33;
  } else {
    t33 = $[90];
  }
  let t34;
  if ($[91] !== pdpSelectedCustomizerTab) {
    t34 = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID ? <PDPSelectUpholsteryDecideLater /> : null;
    $[91] = pdpSelectedCustomizerTab;
    $[92] = t34;
  } else {
    t34 = $[92];
  }
  const t35 = !isLayoutRevampPdp && desktopColorFilterRow;
  let t36;
  if ($[93] !== activeColorFilters || $[94] !== activeNamedFilters || $[95] !== clearAllFiltersButton || $[96] !== desktopColorFilterRow || $[97] !== disabledMaterialIds || $[98] !== fabricFavProps || $[99] !== filterCounts || $[100] !== flashSaleOptionIds || $[101] !== flyoutContainerContent || $[102] !== getFabricFavInfoToShow || $[103] !== isClearanceFabricAvailable || $[104] !== isDesktop || $[105] !== isEditOrder || $[106] !== isLayoutRevampPdp || $[107] !== isMobile || $[108] !== isPdpMode || $[109] !== isSelectedOptionsQuickship || $[110] !== loading || $[111] !== materialThumbnailVariant || $[112] !== mode || $[113] !== moreMaterialsCount || $[114] !== onMoreMaterialsClick || $[115] !== onOptionValueHover || $[116] !== onOptionValueSelection || $[117] !== orderSwatchesSidebar || $[118] !== pdpIsModularBYOProduct || $[119] !== pdpSelectedCustomizerTab || $[120] !== selectedFabric || $[121] !== selectedMaterial || $[122] !== selectedOptionsStockQty || $[123] !== selectedSortOption || $[124] !== showShowAllFabricsButton || $[125] !== showShowLessFabricsButton || $[126] !== showSwatchKitButton || $[127] !== sortByFamilyMaterialThumbnails || $[128] !== sortByRow || $[129] !== sortByTierMaterialThumbnails || $[130] !== toggleColorFilter || $[131] !== toggleNamedFilter || $[132] !== ungroupedMaterialsArray || $[133] !== ungroupedMaterialsToShow || $[134] !== upholsteryFilteredEvent || $[135] !== upholsteryOptionId || $[136] !== upholsteryOptionName) {
    t36 = pdpSelectedCustomizerTab === PDP_CUSTOMIZE_TAB_ID || pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID ? <div>{isLayoutRevampPdp && sortByRow}{!!isPdpMode && pdpSelectedCustomizerTab === PDP_CUSTOMIZE_TAB_ID ? upholsteryOptionName === "Leather" ? <div className="text-sm -mt-8 mx-0 mb-8 font-bold">{getFabricFavInfoToShow("Leather")}</div> : <>{isMobile && <div className="flex justify-between my-1"><h4 className="text-base font-bold">Filter by color</h4>{clearAllFiltersButton}</div>}<div className="mt-0 mx-0 space-y-2 max-[1023px]:-ml-10 max-[1023px]:-mr-5 [&::-webkit-scrollbar]:max-[1023px]:hidden max-[1023px]:pb-6">{isMobile && <PDPUpholsteryColorFilters activeColorFilters={activeColorFilters} showRowInMobile={true} toggleColorFilter={color => {
            toggleColorFilter(color);
            upholsteryFilteredEvent(activeNamedFilters, color, selectedSortOption);
          }} showMobileColorFilter={true} />}<PDPUpholsteryFilters clearAllFiltersButton={clearAllFiltersButton} filtersCollectionVisible={activeNamedFilters} setFiltersCollectionVisible={updatedFilterType => {
            toggleNamedFilter(updatedFilterType);
            upholsteryFilteredEvent(updatedFilterType, activeColorFilters, selectedSortOption);
          }} filterCounts={filterCounts} loading={loading} showFabricFavs={!!fabricFavProps.actions.setOptionAsFav} isClearanceFabricAvailable={isClearanceFabricAvailable} fabricFavInfoToShow={activeNamedFilters.length === 1 && activeNamedFilters[0] === PDP_NAMED_FILTERS.FAVORITES ? getFabricFavInfoToShow(upholsteryOptionName) : ""} variant="PDPSelectUpholstery" />{!loading && ungroupedMaterialsArray.length === 0 && <span className="text-xs font-bold text-gray">Try removing a filter to see more fabric options</span>}</div></> : <div />}{!isLayoutRevampPdp && sortByRow}{isLayoutRevampPdp && desktopColorFilterRow}<div className="flex flex-row justify-between"><PDPActiveFabric isEditOrder={isEditOrder} isModularBundleProduct={pdpIsModularBYOProduct} isSelectedOptionsQuickship={pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID && isSelectedOptionsQuickship} loading={loading} onClick={() => {
          setGalleryType("FabricMultiImg");
          setSidebarOpen(true);
        }} selectedOption={selectedMaterial} selectedOptionsStockQty={selectedOptionsStockQty} size={mode === "quickview" ? "xs" : undefined} showInfoIcon={!!selectedFabric} />{showSwatchKitButton && !isLayoutRevampPdp ? loading ? <Placeholder type="rect" loading={true} style={{
          height: "43px",
          width: "152px",
          borderRadius: "43px"
        }} /> : <div className="mb-2"><PDPFreeSwatchKitButton styling="rainbow-button" onClick={() => {
            setIsOrderSwatchesSidebarOpen(true);
          }} />{orderSwatchesSidebar}</div> : <div />}</div>{selectedSortOption === SORT_BY_OPTIONS.FAMILY ? <>{flyoutContainerContent}{sortByFamilyMaterialThumbnails}</> : selectedSortOption === SORT_BY_OPTIONS.TIER ? sortByTierMaterialThumbnails : <div data-xc="PDPFabricSwatches" className={classNames("max-[1023px]:-ml-5 max-[1023px]:-mr-5 max-[1023px]:md:ml-[-3.333vw] max-[1023px]:md:mr-[-3.333vw]", {
        "max-[1023px]:md:!m-0": mode === "quickview"
      })}>{loading ? <MaterialThumbnailGroupPlaceholder variant={materialThumbnailVariant} /> : <MaterialThumbnailGroup disabledMaterialIds={disabledMaterialIds} enableFlyout={mode === "pdp"} fabricFavProps={fabricFavProps} flashSaleOptionIds={flashSaleOptionIds} isEditOrder={isEditOrder} isModularBundleProduct={pdpIsModularBYOProduct} materials={ungroupedMaterialsToShow} moreMaterialsCount={moreMaterialsCount} onClick={onOptionValueSelection} onHover={onOptionValueHover} onMoreMaterialsClick={onMoreMaterialsClick} optionId={upholsteryOptionId} selectedMaterial={selectedMaterial} showMoreMaterialsOnDesktop={mode === "quickview"} variant={materialThumbnailVariant} />}{showShowAllFabricsButton && <div className="relative pt-6 mt-[-52px] bg-white bg-opacity-70"><div className="bg-white px-[6px]"><CtaButton block={true} color="brand" onClick={() => {
              setHasShowAllFabricsButtonBeenClicked(true);
            }} spacing="sm" styling="outline-button">Show All Fabrics</CtaButton></div></div>}{showShowLessFabricsButton && <div className="px-[6px] pt-4"><CtaButton block={true} color="brand" onClick={() => {
            setHasShowAllFabricsButtonBeenClicked(false);
          }} spacing="sm" styling="outline-button">Show Less Fabrics</CtaButton></div>}</div>}{isLayoutRevampPdp && showSwatchKitButton && !loading && <div className="mt-3 px-[6px]"><PDPFreeSwatchKitButton block={true} styling="outline-button" onClick={() => {
          setIsOrderSwatchesSidebarOpen(true);
        }} />{orderSwatchesSidebar}</div>}{!isLayoutRevampPdp && !!isPdpMode && pdpSelectedCustomizerTab !== PDP_READYTOSHIP_TAB_ID && !isEditOrder && isDesktop ? <div className="mt-4 mx-0 mb-0"><PDPDecideLaterPromo /></div> : <div />}</div> : <div />;
    $[93] = activeColorFilters;
    $[94] = activeNamedFilters;
    $[95] = clearAllFiltersButton;
    $[96] = desktopColorFilterRow;
    $[97] = disabledMaterialIds;
    $[98] = fabricFavProps;
    $[99] = filterCounts;
    $[100] = flashSaleOptionIds;
    $[101] = flyoutContainerContent;
    $[102] = getFabricFavInfoToShow;
    $[103] = isClearanceFabricAvailable;
    $[104] = isDesktop;
    $[105] = isEditOrder;
    $[106] = isLayoutRevampPdp;
    $[107] = isMobile;
    $[108] = isPdpMode;
    $[109] = isSelectedOptionsQuickship;
    $[110] = loading;
    $[111] = materialThumbnailVariant;
    $[112] = mode;
    $[113] = moreMaterialsCount;
    $[114] = onMoreMaterialsClick;
    $[115] = onOptionValueHover;
    $[116] = onOptionValueSelection;
    $[117] = orderSwatchesSidebar;
    $[118] = pdpIsModularBYOProduct;
    $[119] = pdpSelectedCustomizerTab;
    $[120] = selectedFabric;
    $[121] = selectedMaterial;
    $[122] = selectedOptionsStockQty;
    $[123] = selectedSortOption;
    $[124] = showShowAllFabricsButton;
    $[125] = showShowLessFabricsButton;
    $[126] = showSwatchKitButton;
    $[127] = sortByFamilyMaterialThumbnails;
    $[128] = sortByRow;
    $[129] = sortByTierMaterialThumbnails;
    $[130] = toggleColorFilter;
    $[131] = toggleNamedFilter;
    $[132] = ungroupedMaterialsArray;
    $[133] = ungroupedMaterialsToShow;
    $[134] = upholsteryFilteredEvent;
    $[135] = upholsteryOptionId;
    $[136] = upholsteryOptionName;
    $[137] = t36;
  } else {
    t36 = $[137];
  }
  let t37;
  if ($[138] !== t34 || $[139] !== t35 || $[140] !== t36) {
    t37 = <div>{t34}{t35}{t36}</div>;
    $[138] = t34;
    $[139] = t35;
    $[140] = t36;
    $[141] = t37;
  } else {
    t37 = $[141];
  }
  const t38 = !!selectedMaterial?.materialId && isSidebarOpen;
  const t39 = selectedMaterial?.materialId;
  let t40;
  if ($[142] !== galleryType || $[143] !== mode || $[144] !== t38 || $[145] !== t39) {
    t40 = <PDPFabricDetailSidebar isOpen={t38} onClose={onCloseCallback} fabricId={t39} mode={mode} galleryType={galleryType} mobileHideHeader={true} />;
    $[142] = galleryType;
    $[143] = mode;
    $[144] = t38;
    $[145] = t39;
    $[146] = t40;
  } else {
    t40 = $[146];
  }
  let t41;
  if ($[147] !== t33 || $[148] !== t37 || $[149] !== t40) {
    t41 = <div className={t33}>{t37}{t40}</div>;
    $[147] = t33;
    $[148] = t37;
    $[149] = t40;
    $[150] = t41;
  } else {
    t41 = $[150];
  }
  return t41;
};
PDPSelectUpholsteryUI.propTypes = {
  activeNamedFilters: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  allMaterialsLength: PropTypes.number,
  disabledMaterialIds: PropTypes.arrayOf(PropTypes.number),
  fabricFavProps: PropTypes.object,
  filterCounts: productFilterTypes,
  flashSaleOptionIds: PropTypes.arrayOf(PropTypes.number),
  isClearanceFabricAvailable: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  isSelectedOptionsQuickship: PropTypes.bool,
  loading: PropTypes.bool,
  materials: PropTypes.arrayOf(materialPropType),
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onMoreMaterialsClick: PropTypes.func,
  onOptionValueHover: PropTypes.func,
  onOptionValueSelection: PropTypes.func,
  activeColorFilters: PropTypes.array,
  selectedMaterial: materialPropType,
  selectedOptionsStockQty: PropTypes.number,
  toggleColorFilter: PropTypes.func,
  toggleNamedFilter: PropTypes.func,
  upholsteryFilteredEvent: PropTypes.func,
  upholsteryOptionId: PropTypes.number,
  upholsteryOptionName: PropTypes.string,
  // CON-8777 test variant reorders the filter, sort and swatch-kit rows
  isLayoutRevamp: PropTypes.bool
};
export default PDPSelectUpholsteryUI;
function _temp(tierId) {
  return Number(tierId) > 0;
}
function _temp2(a, b) {
  return Number(a) - Number(b);
}